import { axiosInstance } from "../../../utils/axios";

export const getPositions = () => axiosInstance.get('api/v1/control/position-types/').then((response)=> response.data)

export const createPosition = (position) => axiosInstance.post('api/v1/control/position-types/', {
    name: position.name,
}).then((response)=> response.status)

export const updatePosition = (position) => axiosInstance.patch(`api/v1/control/position-types/${position.uuid}/`, {
    name: position.name,
}).then((response)=> response.status)